import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { Drafts } from '../shapes';


const DraftsSvg = (props) => (
  <g>
    <IconBounds />
    <Drafts {...props} />
  </g>
);

DraftsSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

DraftsSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default DraftsSvg;
